import reservationsService from 'services/reservations.service'

const state = () => ({
    hotels: [],
    statuses: [],
    confirms: [],
    markets: [],
    reasonsList: [],
    reasonsMap: {}
})

const getters = {}

const mutations = {
    setHotels(state, hotels) {
        state.hotels = hotels;
    },
    setStatuses(state, statuses) {
        state.statuses = statuses;
    },
    setConfirms(state, confirms) {
        state.confirms = confirms;
    },
    setMarkets(state, markets) {
        state.markets = markets;
    },
    setReasonsList(state, reasons) {
        state.reasonsList = reasons;
        const reasonsMap = {};
        reasons.forEach(reason => {
            reasonsMap[reason.value] = reason.label;
        });
        state.reasonsMap = reasonsMap;
    }
}

const actions = {
    async loadHotels({ commit }) {
        try {
            const response = await reservationsService.getHotels();
            if (response.data.success) {
                commit('setHotels', response.data.data);
                return response.data.data;
            }
        } catch (error) {
            console.error('Error loading hotels:', error);
            throw error;
        }
    },

    async loadStatuses({ commit }) {
        try {
            const response = await reservationsService.getStatuses();
            if (response.data.success) {
                commit('setStatuses', response.data.data);
                return response.data.data;
            }
        } catch (error) {
            console.error('Error loading statuses:', error);
            throw error;
        }
    },

    async loadConfirms({ commit }) {
        try {
            const response = await reservationsService.getConfirms();
            if (response.data.success) {
                commit('setConfirms', response.data.data);
                return response.data.data;
            }
        } catch (error) {
            console.error('Error loading confirms:', error);
            throw error;
        }
    },

    async loadMarkets({ commit }) {
        try {
            const response = await reservationsService.getMarkets();
            if (response.data.success) {
                commit('setMarkets', response.data.data);
                return response.data.data;
            }
        } catch (error) {
            console.error('Error loading markets:', error);
            throw error;
        }
    },

    async loadReasons({ commit }) {
        try {
            const response = await reservationsService.getReasons({ isDropdown: true });
            if (response.data.success) {
                commit('setReasonsList', response.data.data);
                return response.data.data;
            }
        } catch (error) {
            console.error('Error loading reasons:', error);
            throw error;
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
